export const getDeviceVideosLimit = (state) => state.devicesVideosReducer?.limit
